import { lockSelectToWidestOption, search } from "algolia-instant-search";

const { connectSortBy } = instantsearch.connectors;

if (!customElements.get("algolia-sort-by")) {
  class AlgoliaSortBy extends HTMLElement {
    connectedCallback() {
      this.selectElements();

      const customSortBy = connectSortBy(this.renderSortBy.bind(this));

      search.addWidgets([
        customSortBy({
          container: this.content,
          items: [
            { label: "Featured", value: "shopify_products_manual_index_prod" },
            {
              label: "Top Sellers",
              value: "shopify_products_manual_index_prod_order_count_desc",
            },
            {
              label: "Price (asc)",
              value: "shopify_products_manual_index_prod_price_asc",
            },
            {
              label: "Price (desc)",
              value: "shopify_products_manual_index_prod_price_desc",
            },
            {
              label: "Rating (asc)",
              value: "shopify_products_manual_index_prod_rating_asc",
            },
            {
              label: "Rating (desc)",
              value: "shopify_products_manual_index_prod_rating_desc",
            },
            {
              label: "Newest (asc)",
              value: "shopify_products_manual_index_prod_created_at_asc",
            },
            {
              label: "Newest (desc)",
              value: "shopify_products_manual_index_prod_created_at_desc",
            },
          ],
        }),
      ]);
    }

    selectElements() {
      this.selectTemplate = this.querySelector("template#sort-by");
      this.content = this.querySelector("#content");
    }

    renderSortBy(renderOptions, isFirstRender) {
      const { options, currentRefinement, refine, widgetParams } =
        renderOptions;

      if (isFirstRender) {
        const selectClone = this.selectTemplate.content.cloneNode(true);
        widgetParams.container.appendChild(selectClone);
      }

      const select = widgetParams.container.querySelector("select");
      select.innerHTML = "";

      options.forEach((option) => {
        const optionElement = document.createElement("option");
        optionElement.value = option.value;
        optionElement.textContent = option.label;
        optionElement.selected = option.value === currentRefinement;
        select.appendChild(optionElement);
      });

      lockSelectToWidestOption(select);

      select.removeEventListener("change", this.onChange);
      this.onChange = (e) => {
        refine(e.target.value);
      };
      select.addEventListener("change", this.onChange);
    }
  }
  customElements.define("algolia-sort-by", AlgoliaSortBy);
}
